var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWalletbutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4128 0C16.1643 0 20.8256 4.72892 20.8256 10.5637C20.8256 16.3985 16.1643 21.1274 10.4128 21.1274C4.66136 21.1274 0 16.3985 0 10.5637C0 4.72892 4.66136 0 10.4128 0Z",
    fill: "url(#paint0_radial_170_721)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61808 8.15802C8.71285 6.08242 12.1133 6.08242 14.208 8.15802L14.4602 8.40974C14.566 8.5129 14.566 8.68208 14.4602 8.78524L13.5979 9.63942C13.545 9.69306 13.4596 9.69306 13.4067 9.63942L13.061 9.29692C11.5967 7.84854 9.22942 7.84854 7.76512 9.29692L7.39498 9.66418C7.3421 9.71782 7.25668 9.71782 7.2038 9.66418L6.34149 8.81C6.23574 8.70684 6.23574 8.53766 6.34149 8.4345L6.61808 8.15802ZM15.9937 9.92414L16.7624 10.6834C16.8682 10.7866 16.8682 10.9558 16.7624 11.0589L13.301 14.488C13.1952 14.5912 13.0244 14.5912 12.9227 14.488L10.4659 12.0534C10.4415 12.0286 10.3968 12.0286 10.3724 12.0534L7.91562 14.488C7.80986 14.5912 7.63903 14.5912 7.53734 14.488L4.06369 11.0589C3.95794 10.9558 3.95794 10.7866 4.06369 10.6834L4.83245 9.92414C4.9382 9.82098 5.10904 9.82098 5.21073 9.92414L7.6675 12.3588C7.6919 12.3835 7.73665 12.3835 7.76105 12.3588L10.2178 9.92414C10.3236 9.82098 10.4944 9.82098 10.5961 9.92414L13.0529 12.3588C13.0773 12.3835 13.122 12.3835 13.1464 12.3588L15.6032 9.92414C15.7171 9.82098 15.8879 9.82098 15.9937 9.92414Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_170_721",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.45478e-05 10.5641) scale(20.8256 21.1274)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D9DF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletbutton);
export default __webpack_public_path__ + "static/media/walletbutton.47dcac03a89018a59ec9ab0715cc0100.svg";
export { ForwardRef as ReactComponent };